// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sticky {
    position: sticky;
    background-color: white;
    z-index: 2;
}
/**********************************************************/
/*                    DataTable                           */
/**********************************************************/
.TableCell {
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 100%;
    align-items: center;
    color: var(--datatable-cell-text);
}


/**********************************************************/
/*                  SpreadSheet                           */
/**********************************************************/
.SpreadSheetCell {
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 100%;
    align-items: center;
    border: 1px solid var(--spreadsheet-line);
    color: var(--spreadsheet-cell-text);
}
`, "",{"version":3,"sources":["webpack://./src/app/components/datatable/content.column.container.css"],"names":[],"mappings":"AAAA;IAEI,gBAAgB;IAChB,uBAAuB;IACvB,UAAU;AACd;AACA,2DAA2D;AAC3D,2DAA2D;AAC3D,2DAA2D;AAC3D;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,iCAAiC;AACrC;;;AAGA,2DAA2D;AAC3D,2DAA2D;AAC3D,2DAA2D;AAC3D;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,mCAAmC;AACvC","sourcesContent":[".Sticky {\n    position: -webkit-sticky;\n    position: sticky;\n    background-color: white;\n    z-index: 2;\n}\n/**********************************************************/\n/*                    DataTable                           */\n/**********************************************************/\n.TableCell {\n    display: flex;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    height: 100%;\n    align-items: center;\n    color: var(--datatable-cell-text);\n}\n\n\n/**********************************************************/\n/*                  SpreadSheet                           */\n/**********************************************************/\n.SpreadSheetCell {\n    display: flex;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    height: 100%;\n    align-items: center;\n    border: 1px solid var(--spreadsheet-line);\n    color: var(--spreadsheet-cell-text);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
